<script>
	import formBase from '@_system/components/base/form.vue'
	import bankaccbox from './box/bankacc.vue'
	import rcvaccbox from './box/rcvacc.vue'
	import yhzzdform from './jindie/yhzzdform.vue'
	import xjzzdform from './jindie/xjzzdform.vue'
	import xjcqdform from './jindie/xjcqdform.vue'
	import fkdform from './jindie/fkdform.vue'
	import fktkdform from './jindie/fktkdform.vue'
	import skdform from './jindie/skdform.vue'
	
	export default {
		extends: formBase,
		name: 'transferaccountsForm',
		props: {

		},
		data() {
			return {
				isauto:null,
				account: [],
				payrcvMap: [{
					pay: {accName:'温州劲心紧固件有限公司',bankAcc:'86021110000155250'},
					rcv: {accName:'温州劲心紧固件有限公司',bankAcc:'Wenzjinx@163.com'}
				},{
					pay: {accName:'温州劲心紧固件有限公司',bankAcc:'86021110000154436'},
					rcv: {accName:'天津劲功金属科技有限公司',bankAcc:'tjjg201501@sina.com'}
				},{
					pay: {accName:'天津劲心金属科技有限公司',bankAcc:'86021110000155243'},
					rcv: {accName:'天津劲心金属科技有限公司',bankAcc:'tianjjx@126.com'}
				}],
				maindata:[],
				tabledata:[],
				jindierequire:null
			}

		},
		render(h) {
			this.$slots.plug = [
				<bankaccbox ref = "bankaccbox" onBack = {this.bankaccboxBack}
					onSubmit = {this.bankaccboxSubmit}
					isauto = {this.isauto}
					onBoxdataload = {this.bankaccboxload}/>,
				<rcvaccbox ref = "rcvaccbox" onBack = {this.rcvaccboxBack}
					onSubmit = {this.rcvaccboxSubmit}
					onBoxdataload = {this.rcvaccboxload}/>,
				<yhzzdform ref = "yhzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				<xjzzdform ref = "xjzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<xjcqdform ref = "xjcqdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<fkdform ref = "fkdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				<fktkdform ref = "fktkdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				
				<skdform ref = "skdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
						
			
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next){
				formData.jindierequire = formData.jindierequire?JSON.parse(formData.jindierequire):null
				next()
			},
			beforeRender(sourceData) {
				sourceData.jindierequire = sourceData.jindierequire?JSON.stringify(sourceData.jindierequire):null
			},
			jindieformSuccess(e){
				this.fApi.setValue('jindierequire',e.data)
				//console.log(this.$store.state,4444)
				this.fApi.setValue('jindiestaffid',this.$store.state.system.user.id)
			},
			jindieformClear(){
				this.fApi.setValue('jindierequire',null)
			},
			jindierequireButton(){
				let jindietype = this.fApi.getValue('jindietype')
				if(!jindietype){
					this.$message.error('请选择星空模块')
					return
				}
				let maindata = {}
				maindata.payAcc = this.fApi.getValue('payAcc')
				maindata.rcvAcc = this.fApi.getValue('rcvAcc')
				maindata.mark = this.fApi.getValue('mark')
				maindata.jindietype = jindietype
				maindata.amount = this.fApi.getValue('amount')
				this.maindata = maindata
				let jindiedetail = {
					FEXPENSEDEPTID_E:null,
					FCOSTID:null,
					FSETTLETYPEID:null,
					FPURPOSEID:null,
					F_SXTN_DFKM:null,
					F_SXTN_ZZJG:null,
				}
				if(maindata.jindietype == 'AP_PAYBILL'){
					jindiedetail.FPAYTOTALAMOUNTFOR = maindata.amount
					jindiedetail.FPAYAMOUNTFOR_E = maindata.amount
				}
				if(maindata.jindietype == 'AP_REFUNDBILL'){
					jindiedetail.FREFUNDAMOUNTFOR = maindata.amount
					jindiedetail.FREFUNDAMOUNTFOR_E = maindata.amount
				}
				this.tabledata = [jindiedetail]
				this.jindierequire = this.fApi.getValue('jindierequire')
				this.$nextTick(()=>{
					if(jindietype == 'CN_BANKTRANSBILL'){
						this.$refs.yhzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHTRANSBILL'){
						this.$refs.xjzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHACCESSBILL'){
						this.$refs.xjcqdform.modal_show()
					}
					if(jindietype == 'AP_PAYBILL'){
						this.$refs.fkdform.modal_show()
					}
					if(jindietype == 'AP_REFUNDBILL'){
						this.$refs.fktkdform.modal_show()
					}
					if(jindietype == 'AR_RECEIVEBILL'){
						this.$refs.skdform.modal_show()
					}
				})				
			},
			jindietypeChange(){
				this.fApi.setValue('jindierequire',null)
			},
			bankaccboxBack(){
				
			},
			bankaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('corpCode',e.data.corpCode)
					this.fApi.setValue('payAcc',e.data.bankAcc)
					this.fApi.setValue('paybank',e.data.bankType)
					this.fApi.setValue('payName',e.data.accName)
				}
			},
			bankaccboxload(){
				
			},
			
			
			
			rcvaccboxBack(){
				
			},
			rcvaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('rcvbank', e.data.bankType)
					this.fApi.setValue('rcvAcc', e.data.bankAcc)
					this.fApi.setValue('rcvName', e.data.accName)
					this.fApi.setValue('wlnacc', e.data.acc_name)
					this.fApi.setValue('rcvbankName', null)
				}
			},
			rcvaccboxload(){
				
			},
			
			
			payAccButton(){
				if(!this.isauto){
					this.$message.error('请选择是否财资打款')
					return
				}
				this.$refs.bankaccbox.initList()
				this.$refs.bankaccbox.box.alertBox()
			},
			wlnaccButton(){
				this.$refs.rcvaccbox.initList()
				this.$refs.rcvaccbox.box.alertBox()
			},
			beforeInit(next) {
				this.$api.transferaccounts.queryAccount().then((res) => {
					this.account = res
					next()
				}, () => {
					this.$message.error('获取财资账号失败')
				})
			},
			beforeFormCreate(rule) {
				
				let options = this.account.map((item) => {
					return {
						label: item.accName + '【' + item.bankAcc + '】' + item.bankType,
						value: item.accName + '【' + item.bankAcc + '】',
					}
				})
				rule.forEach((item) => {
					if (item.field == 'payaccName') {
						item.options = options
					}
					if (item.field == 'rcvaccName') {
						item.options = options
					}
				})
				
			},
			isautoChange(e){
				this.isauto = e
			},
			regestEvent() {
				if(this.extra.sourceordercode){
					this.$nextTick(()=>{
						this.fApi.setValue('sourceordercode', this.extra.sourceordercode)
						this.fApi.setValue('amount', this.extra.amount)
						this.fApi.setValue('uses', this.extra.uses)						
						this.rcvaccNameChange(this.extra.rcvAcc)
					})
				}
			},
			payaccNameChange(e) {
				let accinfo = this.account.find((item) => {
					return e == item.accName + '【' + item.bankAcc + '】' || item.bankAcc == e
				})
				if (accinfo) {
					this.fApi.setValue('payAcc', accinfo.bankAcc)
					this.fApi.setValue('payName', accinfo.accName)
					this.fApi.setValue('paybank', accinfo.bankType)
					this.fApi.setValue('corpCode', accinfo.corpCode)
					this.fApi.setValue('balance', accinfo.bal)
					
				} else {
					this.fApi.setValue('paybank', null)
					this.fApi.setValue('payAcc', null)
					this.fApi.setValue('payName', null)
					this.fApi.setValue('corpCode', null)
					this.fApi.setValue('balance',null)
				}

			},
			afterBoxSubmit(){
				this.fApi.setValue('rcvaccName', null)
			},
			rcvaccNameChange(e) {
				if(e){
					let accinfo = this.account.find((item) => {
						return e == item.accName + '【' + item.bankAcc + '】' || item.bankAcc == e
					})
					if (accinfo) {
						if(this.id==0){
							this.checkmap(accinfo)
						}				
						if (accinfo.bankAcc == 'tjjg201501@sina.com') {
							this.fApi.setValue('rcvAcc', '2088888800584399423')
						} else if (accinfo.bankAcc == 'tianjjx@126.com') {
							this.fApi.setValue('rcvAcc', '2088884500256791521')					
						} else if (accinfo.bankAcc == 'Wenzjinx@163.com') {
							this.fApi.setValue('rcvAcc', '2088886900377022509')
						} else {
							this.fApi.setValue('rcvAcc', accinfo.bankAcc)
						}

						this.fApi.setValue('rcvbank', accinfo.bankType)
						this.fApi.setValue('rcvName', accinfo.accName)
						this.fApi.setValue('rcvbankName', accinfo.bankName)
						// this.fApi.setValue('rcvaccName', accinfo.accName + '【' + accinfo.bankAcc + '】')
					} else {
						this.fApi.setValue('rcvbank', null)
						this.fApi.setValue('rcvAcc', null)
						this.fApi.setValue('rcvName', null)
						this.fApi.setValue('rcvbankName', null)
					}
					this.fApi.setValue('relatedcompanyid', null)
					this.fApi.setValue('relatedcompanyname', null)
				}

			},
			checkmap(accinfo){
				let mapaccinfo = null
				let hasmap = this.payrcvMap.find((item)=>{
					return item.rcv.bankAcc == accinfo.bankAcc
				})
				if(hasmap){
					mapaccinfo = this.account.find((item) => {
						return item.bankAcc == hasmap.pay.bankAcc
					})
					if(mapaccinfo){
						let payaccName = mapaccinfo.accName + '【' + mapaccinfo.bankAcc + '】'
						this.fApi.setValue('payaccName', payaccName)
						this.payaccNameChange(payaccName)
					}
				}
			},
			getAccountInfo(id) {
				let emunitem = window.systemData.emun.find((item) => {
					return item.id == id
				})
				let accinfo = null
				if (emunitem) {
					accinfo = this.account.find((item) => {
						return item.bankAcc == emunitem.alias
					})
				}
				return accinfo
			},
			queryAccount() {
				this.$api.transferaccounts.queryAccount().then(() => {

				})
			}
		},
		components: {

		}
	}
</script>